// extracted by mini-css-extract-plugin
module.exports = {"jenga-item":"jenga-item_jenga-item__H0qpO","title":"jenga-item_title__nn8PO","body":"jenga-item_body__Nh4sD"};